import React from 'react';
import Image from 'Shared/ImageFallback';
import { epiPropertyValue } from '@avensia/nitro5-scope-episerver';
import * as styles from './base.scss';
const customProductImage = require('../../../../styles/images/custom-product.svg');
const getImageUrl = (imageUrl, isCustom, useImageUrlForCustom) => {
    if (isCustom) {
        return useImageUrlForCustom && imageUrl
            ? imageUrl
            : customProductImage;
    }
    return imageUrl;
};
const ProductImage = ({ imageUrl, displayName, size, isCustom, useImageUrlForCustom }) => (React.createElement("div", { className: styles.image },
    React.createElement(Image, { src: getImageUrl(imageUrl, isCustom, useImageUrlForCustom), alt: typeof displayName === 'string' ? displayName : epiPropertyValue(displayName), size: size, maxSize: size, itemProp: "image", fadeIn: true })));
export default ProductImage;
